import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the checkUserEmail state domain
 */

const selectCheckUserEmailDomain = state =>
  state.checkUserEmail || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by CheckUserEmail
 */

const selectCheckUserEmailData = () =>
  createSelector(
    selectCheckUserEmailDomain,
    substate => substate.checkUserEmailData,
  );

const selectCheckUserEmailLoading = () =>
  createSelector(
    selectCheckUserEmailDomain,
    substate => substate.loadingCheckEmail,
  );

const selectCheckUserEmailError = () =>
  createSelector(
    selectCheckUserEmailDomain,
    substate => substate.error,
  );

const selectCheckUserEmailDeleteSuccessful = () =>
  createSelector(
    selectCheckUserEmailDomain,
    substate => substate.deleteSuccessful,
  );

const makeSelectCheckUserEmail = () =>
  createSelector(
    selectCheckUserEmailDomain,
    substate => substate,
  );

export default makeSelectCheckUserEmail;
export {
  selectCheckUserEmailDomain,
  selectCheckUserEmailData,
  selectCheckUserEmailLoading,
  selectCheckUserEmailError,
  selectCheckUserEmailDeleteSuccessful,
};
